import React from 'react';
import { Grid, Card, Typography } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const AggregatedGrid = () => {
  return (
    <div>
      {/* Second Row: Input Data Warning */}
      <Grid container spacing={2} sx={{ marginBottom: 1, marginTop: 1 }}>
        <Grid item xs={12} md={3}></Grid>
        <Grid item xs={12} md={8}>
          <Card
            sx={{
              p: 2,
              display: 'inline-flex',
              alignItems: 'center',
              backgroundColor: '#ba3da0',
              boxShadow: 3,
              borderRadius: '16px',
            }}
          >
            <WarningAmberIcon sx={{ marginRight: 1, color: '#ffbe00' }} />
            <Typography variant="h6" color="white">
              Input data must comply with the following requirements:
            </Typography>
          </Card>
        </Grid>
        <Grid item xs={12} md={2}></Grid>
      </Grid>

      {/* Third Row: Existing Four Boxes */}
      <Grid container spacing={2} sx={{ marginBottom: 2 }}>
        <Grid item xs={12} md={3}>
          <Card
            sx={{
              p: 2,
              backgroundColor: '#ba3da0',
              color: 'white',
              boxShadow: 3,
              borderRadius: '16px',
              textAlign: 'center',
            }}
          >
            <Typography variant="subtitle1">Max Date Range</Typography>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              24 months
            </Typography>
          </Card>
        </Grid>

        <Grid item xs={12} md={3}>
          <Card
            sx={{
              p: 2,
              backgroundColor: '#ba3da0',
              color: 'white',
              boxShadow: 3,
              borderRadius: '16px',
              textAlign: 'center',
            }}
          >
            <Typography variant="subtitle1">Max Data Size</Typography>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              1 GB
            </Typography>
          </Card>
        </Grid>

        <Grid item xs={12} md={3}>
          <Card
            sx={{
              p: 2,
              backgroundColor: '#ba3da0',
              color: 'white',
              boxShadow: 3,
              borderRadius: '16px',
              textAlign: 'center',
            }}
          >
            <Typography variant="subtitle1">Min Time Resolution</Typography>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              Hourly
            </Typography>
          </Card>
        </Grid>

        <Grid item xs={12} md={3}>
          <Card
            sx={{
              p: 2,
              backgroundColor: '#ba3da0',
              color: 'white',
              boxShadow: 3,
              borderRadius: '16px',
              textAlign: 'center',
            }}
          >
            <Typography variant="subtitle1">PV Production</Typography>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              Optional
            </Typography>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default AggregatedGrid;
